export default __webpack_public_path__ + "static/media/ticket.1324197f.png";